import { MenuWrapper } from '../BravoHeader/components';
import MobileMenuIcon from 'assets/images/mobile-menu.svg';
import CloseMenuIcon from 'assets/images/close-menu.svg';
import { useState, useEffect, useContext } from 'react';

import { useNavigate } from 'react-router-dom';
import { Grid, TabsProps, Tabs, List, Dropdown } from 'antd';
const { useBreakpoint } = Grid;
import HomeNavIcon from 'assets/images/liHome/home-nav.svg';
import ClaimNavIcon from 'assets/images/liHome/Make-a-Claim.svg';
import BenefitsNavIcon from 'assets/images/liHome/My-Benefits.svg';
import PoliciesNavIcon from 'assets/images/liHome/Policies.svg';
import SupportNavIcon from 'assets/images/liHome/Support.svg';
import GlobeNavIcon from 'assets/images/liHome/globe-nav.svg';
import ProfileNavIcon from 'assets/images/liHome/profile-nav.svg';
import LogoutNavIcon from 'assets/images/liHome/log-out-nav.svg';
import PaymentNavIcon from 'assets/images/liHome/payment-nav.svg';
import EditNavIcon from 'assets/images/liHome/Edit.svg';
import { useTranslation } from 'react-i18next';
import ChevronRight from 'assets/images/home/chevron-right.svg';
import ChevronLeft from 'assets/images/liHome/chevron-left.svg';
import { HomeContext } from 'contexts/home/context';
import { usePatchReminder, useLogLogout } from 'all-in-one-shared-api';
import { sessionStorageService } from 'utils/SessionStorageService';
import { useKeycloakReady } from 'hooks';
import { osName, osVersion } from 'react-device-detect';
import { useSWRConfig } from 'swr';
import { UserAccessActionTypes } from '../../../contexts/home/actions';
import { CHINESE_SYMBOL, ENGLISH_SYMBOL } from 'i18n';
import { HelpMenu } from '../BravoHeader/components';
import _ from 'lodash';
import { removeCookie } from 'utils/cookies';

import './CollapseNav.less';
type listProps = {
  icon?: string;
  title: string;
  navigate?: string;
  dropdown?: boolean;
};
interface navListProps {
  nlist: Array<listProps>;
}
const CollapseNav = (props: {
  status?: boolean;
  changeShowColNav: (status: boolean) => void;
  showViewAsUser?: boolean;
}) => {
  const { t, i18n } = useTranslation();
  const [openStutas, setOpenStutas] = useState(false);
  const [showLanguage, setShowLanguage] = useState(false);
  const navigate = useNavigate();
  const { sm } = useBreakpoint();
  const toggleStatus = () => {
    setOpenStutas(!openStutas);
    if (!openStutas) props.changeShowColNav(true);
  };

  //   const drawerIn = document.getElementById('drawer-in');
  useEffect(() => {
    if (openStutas) {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    }
  }, [openStutas]);
  useEffect(() => {
    if (!props.status) setOpenStutas(false);
  }, [props.status]);
  const ebList = [
    {
      icon: HomeNavIcon,
      title: 'header.home',
      navigate: '/home',
    },
    {
      icon: ClaimNavIcon,
      title: 'header.claims',
      navigate: '/claims',
    },
    {
      icon: BenefitsNavIcon,
      title: 'header.benefits',
      navigate: '/benefits',
    },
    {
      icon: PoliciesNavIcon,
      title: 'header.documents',
      navigate: '/documents',
    },
    {
      icon: SupportNavIcon,
      title: 'header.help',
      navigate: '/help',
      dropdown: true,
    },
    {
      icon: GlobeNavIcon,
      title: 'life.guide.languageNav',
    },
    {
      icon: ProfileNavIcon,
      title: 'life.guide.myProfileNav',
      navigate: '/profile',
    },
    {
      icon: LogoutNavIcon,
      title: 'life.guide.logoutNav',
    },
  ];
  const liList = [
    {
      icon: HomeNavIcon,
      title: 'header.LIHome',
      navigate: '/LIHome',
    },
    {
      icon: PoliciesNavIcon,
      title: 'header.LIPolicies',
      navigate: '/LIPolicies',
    },
    {
      icon: PaymentNavIcon,
      title: 'header.LIPayment',
      navigate: '/LIPayment', // 修改为不带查询参数
      state: { tabs: 1 }, // 通过state传递tabs参数
    },
    {
      icon: EditNavIcon,
      title: 'header.LIPolicyUp',
      navigate: '/LIPolicyUp',
    },
    {
      icon: SupportNavIcon,
      title: 'header.LISupport',
      navigate: '/LISupport',
    },
    {
      icon: GlobeNavIcon,
      title: 'life.guide.languageNav',
    },
    {
      icon: ProfileNavIcon,
      title: 'life.guide.myProfileNav',
      navigate: '/LifeAccount',
    },
    {
      icon: LogoutNavIcon,
      title: 'life.guide.logoutNav',
    },
  ];
  const globeList = [
    {
      title: 'English',
    },
    {
      title: '繁',
    },
  ];
  const { mutate } = useSWRConfig();
  const { keycloak, tokenParsed } = useKeycloakReady();

  const { state: homeData, dispatch } = useContext(HomeContext);
  const news = _.get(homeData, 'userAccess.reminders[0]');
  const patchReminder = usePatchReminder(keycloak.token || '', news?.id || 0);
  const logLogout = useLogLogout({
    sourceOfRequest: window.location.pathname,
    media: 'WEB',
    authToken: keycloak.token,
    device: osName,
    deviceVersion: osVersion,
  });
  const onLogoutPressed = async () => {
    try {
      news?.id && (await patchReminder());
      sessionStorageService.clear();
      removeCookie('KeycloakTokens');

      await logLogout();
      await mutate(() => true, undefined, { revalidate: false });
    } catch (error) {
      // TODO: show a https://ant.design/components/notification/ ?
      // console.log('onLogoutPressed()->Error occurred', error);
    }

    await keycloak.logout();
    dispatch({ type: UserAccessActionTypes.LOGOUT });
  };
  const redirectHandle = (item: listProps) => {
    if (item.navigate) {
      navigate(item.navigate);
      setOpenStutas(false);
    } else if (item?.title.includes('logoutNav')) {
      onLogoutPressed();
    } else if (item?.title.includes('languageNav')) {
      setShowLanguage(true);
    }
  };
  const NavList = ({ nlist }: navListProps) => {
    return (
      <div className="tabs-wrapper">
        <List
          itemLayout="horizontal"
          dataSource={nlist}
          renderItem={(item) =>
            item.dropdown ? (
              <Dropdown overlay={<HelpMenu changeOpen={props.changeShowColNav} />} trigger={['click']}>
                <List.Item style={{ cursor: 'pointer' }}>
                  <List.Item.Meta title={t(`${item.title}`)} avatar={<img src={item.icon} />} />
                  <div>
                    <img src={ChevronRight} alt="" />
                  </div>
                </List.Item>
              </Dropdown>
            ) : (
              <>
                <List.Item onClick={() => redirectHandle(item)} style={{ cursor: 'pointer' }}>
                  <List.Item.Meta title={t(`${item.title}`)} avatar={<img src={item.icon} />} />
                  <div>
                    <img src={ChevronRight} alt="" />
                  </div>
                </List.Item>
              </>
            )
          }
        />
      </div>
    );
  };
  const NavListL = ({ nlist }: navListProps) => {
    return (
      <div className="tabs-wrapper">
        <List
          style={{ color: 'white' }}
          itemLayout="horizontal"
          dataSource={nlist}
          renderItem={(item) => (
            <List.Item onClick={() => changeLanguage(item.title)} style={{ cursor: 'pointer' }}>
              <List.Item.Meta title={t(`${item.title}`)} />
            </List.Item>
          )}
        />
      </div>
    );
  };
  // const [items, setItems] = useState<TabsProps['items']>([
  //   {
  //     key: '1',
  //     label: 'Employee Benefits',
  //     children: <NavList nlist={ebList}></NavList>,
  //   },
  //   {
  //     key: '2',
  //     label: 'Life Insurance',
  //     children: <NavList nlist={liList}></NavList>,
  //   },
  // ]);
  const allitems: TabsProps['items'] = [
    {
      key: '1',
      label: `${t('life.guide.ebnav')}`,
      children: <NavList nlist={ebList}></NavList>,
    },
    {
      key: '2',
      label: `${t('life.guide.linav')}`,
      children: <NavList nlist={liList}></NavList>,
    },
  ];
  const items =
    tokenParsed?.ebClientKey !== '' && tokenParsed?.ilClientKey !== ''
      ? allitems
      : tokenParsed?.ebClientKey !== ''
      ? [allitems[0]]
      : [allitems[1]];
  const onChange = () => {
    //
  };
  const changeLanguage = async (lang: string) => {
    let nextLang = '';
    // if (i18n.language == ENGLISH_SYMBOL) {
    //   nextLang = CHINESE_SYMBOL;
    // } else {
    //   nextLang = ENGLISH_SYMBOL;
    // }
    if (lang == 'English') {
      nextLang = ENGLISH_SYMBOL;
    } else {
      nextLang = CHINESE_SYMBOL;
    }

    await i18n.changeLanguage(nextLang);
    setShowLanguage(false);
    sessionStorageService.set('i18nLanguage', nextLang);
  };
  const changeLanguageShow = () => {
    setShowLanguage(false);
  };
  return (
    <MenuWrapper>
      {openStutas ? (
        <img src={CloseMenuIcon} alt="mobile menu" onClick={toggleStatus} style={{ display: 'block' }} />
      ) : (
        <img src={MobileMenuIcon} alt="mobile menu" onClick={toggleStatus} />
      )}
      <div
        className={`drawer-wrapper ${openStutas ? 'slide-in' : ''}`}
        style={{ width: `${!sm ? '100%' : '50%'}`, top: props.showViewAsUser ? 126 : 62 }}
      >
        {!showLanguage && <Tabs defaultActiveKey="1" items={items} onChange={onChange} size="large" centered />}
        {showLanguage && (
          <>
            <div style={{ margin: '0 16px', cursor: 'pointer' }} onClick={changeLanguageShow}>
              <img src={ChevronLeft} alt="" style={{ verticalAlign: 'middle' }} />
              <span style={{ color: 'var(--primary-color)', marginLeft: '10px', verticalAlign: 'middle' }}>
                {t('life.home.back')}
              </span>
            </div>
            <NavListL nlist={globeList}></NavListL>
          </>
        )}
      </div>
    </MenuWrapper>
  );
};

export default CollapseNav;
